import ConversationType from 'owa-service/lib/contract/ConversationType';
import { ITEM_CLASS_SMIME } from 'owa-smime-adapter/lib/utils/constants';

/**
 * Returns true if the conversation contains S/MIME item
 */
export default function doesConversationContainSmimeItem(conversation: ConversationType): boolean {
    return (
        conversation &&
        conversation.ItemClasses &&
        conversation.ItemClasses.length > 0 &&
        conversation.ItemClasses.some(itemClass => itemClass.indexOf(ITEM_CLASS_SMIME) === 0)
    );
}
